import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const SitemapPageBannerSection = ({ className }) => {
  const locale = useLocale();
  const pathPrefix = "page.sitemap.banner";

  return (
    <Banner
      className={className}
      title={<DynamicText path={`${pathPrefix}.title.${locale}`} tag="h1" />}
      image={{ path: `${pathPrefix}.image`, src: "/assets/banners/default.webp" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`${pathPrefix}.text.${locale}`} />
        </Col>
      </Row>
    </Banner>
  );
};
